import Vue from 'vue'
import Router from 'vue-router'
import ArticleDetail from '@/components/ArticleDetail'
import SkillCodeArticleDetail from '@/components/SkillCodeArticleDetail'
import ArticleDetailDiagnose from '@/components/ArticleDetailDiagnose'
import UserRule from '@/components/UserRule'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import ClapUserRule from '@/components/ClapUserRule'
import ClapPrivacyPolicy from '@/components/ClapPrivacyPolicy'
import DiagnoseUserRule from '@/components/DiagnoseUserRule'
import DiagnosePrivacyPolicy from '@/components/DiagnosePrivacyPolicy'
import DiagnosePrivacyPolicyTeacher from '@/components/DiagnosePrivacyPolicyTeacher'
import DiagnoseUserRuleTeacher from '@/components/DiagnoseUserRuleTeacher'
import CircleDetail from '@/components/CircleDetail'
import EduDownload from '@/components/EduDownload'
import DailyRecommendPage from '../modules/kuaizhen/DailyRecommendPage'
import ArticleInfoPage from '../components/ArticleInfoPage'
import AudioInfoPage from '../modules/jyq/AudioInfoPage'
import AutoDownload from '../components/AutoDownload'
import CancellationNotice from '../components/CancellationNotice'
import ARPolicy from '../components/ARPolicy'
import VideoInfoPage from '../components/VideoInfoPage'
import CollectInfo from "../components/CollectInfo"
import SuccessPage from "../components/SuccessPage"
import SkillUserRule from "../components/SkillUserRule"
import SkillPrivacyPolicy from "../components/SkillPrivacyPolicy"
import SkillLicence from "../components/SkillLicence"
import BusnisessCert from "../components/busnisessCert"
import JnmUserRule from "../components/JnmUserRule"
import JnmPrivacyPolicy from "../components/JnmPrivacyPolicy"
import JnmLicence from "../components/JnmLicence"
import JnmBusnisessCert from "../components/JnmbusnisessCert"
import SchoolInfoPage from "../components/SchoolInfoPage"
Vue.use(Router)
// 教育圈路由
const jiaoYuQuanPages = [{
    path: '/ArticleDetail',
    name: 'ArticleDetail',
    component: ArticleDetail
  },
  {
    path: '/ArticleInfoPage',
    name: 'ArticleInfoPage',
    component: ArticleInfoPage
  },
  {
    path: '/audio',
    name: 'AudioInfoPage',
    component: AudioInfoPage
  },
  {
    path: '/autoDownload',
    name: 'AutoDownload',
    component: AutoDownload,
    meta: {
      title: '技能码APP下载'
    }
  }, {
    path: '/videoDetail',
    name: 'VideoInfoPage',
    component: VideoInfoPage

  }, {
    path: '/SkillCodeArticleDetail',
    name: 'SkillCodeArticleDetail',
    component: SkillCodeArticleDetail,
    meta: {
      title: '资讯'
    }
  },{
    path:"/SchoolInfoPage",
    name: 'SchoolInfoPage',
    component: SchoolInfoPage,
    meta: {
      title: '常信廉洁文化作品展'
    }
  }
]


// 快诊路由
const kuaiZhenPages = [{
  path: '/ArticleDetailDiagnose',
  name: 'ArticleDetailDiagnose',
  component: ArticleDetailDiagnose,
  meta: {
    title: '园丁快诊'
  }
}, {
  path: '/DailyRecommendPage',
  name: 'DailyRecommendPage',
  component: DailyRecommendPage,
  meta: {
    title: '园丁快诊'
  }
}]

// 协议
const agreementPages = [{
    path: '/UserRule',
    name: 'UserRule',
    component: UserRule
  }, {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  }, {
    path: '/ARPolicy',
    name: 'ARPolicy',
    component: ARPolicy
  }, {
    path: '/CircleDetail',
    name: 'CircleDetail',
    component: CircleDetail
  }, {
    path: '/EduDownload',
    name: 'EduDownload',
    component: EduDownload
  }, {
    path: '/CancellationNotice',
    name: 'CancellationNotice',
    component: CancellationNotice
  }

]

// 活动页路由
const activityPages = [{

    path: '/CollectInfo',
    name: 'CollectInfo',
    component: CollectInfo,
    meta: {
      title: '未来职教'
    }
  }, {
    path: '/SuccessPage',
    name: 'SuccessPage',
    component: SuccessPage,
    meta: {
      title: '未来职教'
    }
  },
  {
    path: '/SkillUserRule',
    name: 'SkillUserRule',
    component: SkillUserRule
  }, {
    path: '/SkillPrivacyPolicy',
    name: 'SkillPrivacyPolicy',
    component: SkillPrivacyPolicy
  }, {
    path: '/SkillLicence',
    name: 'SkillLicence',
    component: SkillLicence
  },
  {
    path: '/BusnisessCert',
    name: 'BusnisessCert',
    component: BusnisessCert
  },
  {
    path: '/JnmUserRule',
    name: 'JnmUserRule',
    component: JnmUserRule,
    meta: {
      title: '技能码'
    }
  }, {
    path: '/JnmPrivacyPolicy',
    name: 'JnmPrivacyPolicy',
    component: JnmPrivacyPolicy,
    meta: {
      title: '技能码'
    }
  }, {
    path: '/JnmLicence',
    name: 'JnmLicence',
    component: JnmLicence,
    meta: {
      title: '技能码'
    }
  },
  {
    path: '/JnmBusnisessCert',
    name: 'JnmBusnisessCert',
    component: JnmBusnisessCert,
    meta: {
      title: '技能码'
    }
  },
]

export default new Router({
  // mode: 'history',
  // base: '/wxshare',
  routes: [
    ...jiaoYuQuanPages,
    ...kuaiZhenPages,
    ...agreementPages,
    ...activityPages
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js